module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch005_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch006#ch006_1"
    }
  }, [_c('em', [_vm._v("Foreword")])]), _vm._v(" "), _c('em', [_vm._v("by Jo Ann Jenkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch007#ch007_1"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch007#ch007_1"
    }
  }, [_c('strong', [_vm._v("Reimagined Lives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch008#ch008_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch008#ch008_1"
    }
  }, [_c('strong', [_vm._v("The End of Work As We Know It")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch009#ch009_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch009#ch009_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Work—What Do You Do?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch010#ch010_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch010#ch010_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Calling—Should You Quit Your Day Job?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch011#ch011_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch011#ch011_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Gifts—How Do You Do It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch012#ch012_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch012#ch012_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Passions—Why Do You Do It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch013#ch013_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch013#ch013_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Values—Where Do You Do It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch014#ch014_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch014#ch014_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reimagining Legacy—Have You Played Your Music?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch015#ch015_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch016#ch016_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch018#ch018_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Authors")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faad73d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch005.vue
// module id = 69
// module chunks = 0